import { withDefaultTheme } from "./ThemeProvider";
import { StyledTypography } from "./typography/typography.styles";
import { IStyledTypography } from "./typography/typography.types";

const Typography = (props: IStyledTypography) => <StyledTypography {...props} />;

export default withDefaultTheme(Typography);
